@if(service.viewDroplistItems.length){
<div class='configuration-commitments-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.Commitments) {
	<configuration-commitments-commitments-view-part></configuration-commitments-commitments-view-part>
	}
	}
	}
</div>
}